export const isPage = (pathnames: string[]) =>
  pathnames.some(path => window.location.pathname.includes(path));
